import React from "react";
import { Card, Row, Col } from "antd";

const DemandInLastSevenDays = () => {
  return (
    <div className="DemandInLastSevenDays pricingMatricsCards">
      <Row justify="space-between">
        <Col span={7}>
          <Card>
            <h1>-</h1>
            <p>Guest Cards</p>
          </Card>
        </Col>
        <Col span={7}>
          <Card>
            <h1>-</h1>
            <p>Applications</p>
          </Card>
        </Col>
        <Col span={7}>
          <Card>
            <h1>-%</h1>
            <p>Conversion Rate</p>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DemandInLastSevenDays;
